import ng from 'angular';
import moment from 'moment';
import { ITrabalhador } from '../../../models/trabalhador.model';

export class ModalRetornarDoAfastamentoController implements ng.IController {

    static $inject = ['entity', '$uibModalInstance'];

    public form: ng.IFormController;
    public dataAtual = moment().startOf('day');
    public dataDeRetorno?: string;
    public busy = false;

    constructor(
        public entity: ITrabalhador,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService
    ) {
    }

    submit() {
        this.$uibModalInstance.close(this.dataDeRetorno);
    }

    close() {
        this.$uibModalInstance.dismiss('fechar');
    }
}
